var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c(
        "b-form",
        { attrs: { id: "form-material", "data-vv-scope": "form-material" } },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12 scroll-area" }, [
              _c(
                "ul",
                { staticClass: "list-group mt-5" },
                _vm._l(_vm.materialServices, function(service) {
                  return _c(
                    "li",
                    { key: service.id, staticClass: "list-group-item" },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-10" }, [
                          _c(
                            "h6",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip",
                                  value: service.name,
                                  expression: "service.name"
                                }
                              ]
                            },
                            [_vm._v(" " + _vm._s(service.name) + " ")]
                          ),
                          _c("small", { staticClass: "text-muted" }, [
                            _vm._v(" " + _vm._s(service.code) + " ")
                          ])
                        ]),
                        _c(
                          "div",
                          { staticClass: "col-md-2" },
                          [
                            _c("b-form-checkbox", {
                              attrs: {
                                switch: "",
                                size: "lg",
                                value: true,
                                "unchecked-value": false,
                                "data-cy": "select-service"
                              },
                              model: {
                                value: service.selected,
                                callback: function($$v) {
                                  _vm.$set(service, "selected", $$v)
                                },
                                expression: "service.selected"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                }),
                0
              )
            ])
          ])
        ]
      ),
      _c("vs-divider"),
      _c(
        "div",
        { staticClass: "text-right" },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "ripple",
                  rawName: "v-ripple.400",
                  value: "rgba(255, 255, 255, 0.15)",
                  expression: "'rgba(255, 255, 255, 0.15)'",
                  modifiers: { "400": true }
                }
              ],
              attrs: { variant: "primary", "data-cy": "save-material" },
              on: { click: _vm.attemptSaveMaterialServices }
            },
            [_vm._v(" Guardar ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }